export const messages = {
  configurePageTitle: 'Configure Offer',
  updatePageTitle: 'Update Offer',
  subtitle:
    'Encourage future visits by offering members benefits or points based on purchase behavior',
};
